import Axios from "axios";

export const SelectVend = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/Caisse?vend=&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({
        type: "Vend_SELECT",
        payload: response.data,
      });
    });
  };
};
